const PATH = "/api/internal";

const ENDPOINTS = {
  OWNER_BOOKINGS_FILTER_PHONE: "/bookings/filter/phone/",
};

export type OwnerEndpoints = keyof typeof ENDPOINTS;
export const OwnerCollection = { PATH, ENDPOINTS };
